import { Container } from "./styles";

const BtnCancel = ({ ...rest }) => <Container type="button" {...rest} />;

export default BtnCancel;
